import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import AssetManagementApiService from './AssetManagementApiService'
import { setUpfitOption } from 'Store/AssetManagement/UpfitOption/UpfitOptionAction';
import { GET_UPFIT_OPTION } from 'Store/AssetManagement/UpfitOption/UpfitOptionType';
import { apiMethod, apiType, API_URL } from 'utils';
import { IPayload } from 'Model/IPayload';

function* getUpfitOptions(request: any): any {
    let payloadData : IPayload = {
        apiMethod: apiMethod.GET,
        apiType: apiType.AssetManagement,
        endpoint: `assets/dropdown/vehicle/upfitoption/${request.subTypeId}`,
        payload : null
    }

    try {
        yield put(globalLoaderText("Fetching Values..."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        if (response?.length > 0) {
            const defaultOption = {
                text: "Select Upfit Option",
                value: null
            };
            response.unshift(defaultOption);
        }
        yield put(setUpfitOption(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setUpfitOption([]))
        yield put(globalLoaderText(""));
    }
}

function* watchGetUpfitOption() {
    yield takeEvery(GET_UPFIT_OPTION, getUpfitOptions)
}

export default function* combinedSaga() {
    yield all([
        watchGetUpfitOption()
    ])
}
